import React from 'react';
import './time-filter.style.css';
import {
    Link,
} from 'react-router-dom'

const TimeFilter = (props) => {
    const filterThai = { "day": "วันนี้", "week": "สัปดาห์", "month": "เดือน", "year": "ปี", "lastest": "ล่าสุด" }
    return (
        <div className="post-head">
            {props.filterList.map((filter, idx) => <EachFilter key={idx} filter={filter} filterThai={filterThai[filter]} focusFilter={props.focusFilter} onFilterClick={props.onFilterClick} tagName={props.tagName} searchText={props.searchText} />)}
        </div>
    )
}
const EachFilter = (props) => {
    const path = (props.tagName !== undefined ? `/tag/${props.tagName}` : props.searchText ? '/search':'') + (props.filter !== "Feed" ? `/filter/${props.filter}` : "") + ( props.searchText ? `?q=${props.searchText}`:'')
    return (
        <Link className="a-link" to={path} >
            <div className={props.focusFilter === props.filter ? "head-filter filter-focus" : "head-filter"} onClick={() => props.onFilterClick(props.filter)}>{props.filterThai}</div>
        </Link>
    )
}

export default TimeFilter;
